import { Link } from "react-router-dom";
import { Reveal } from "@/components/motion/Reveal";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export function ROISection() {
  return (
    <div className="space-y-10">
      <Reveal stagger={60} className="text-center space-y-4 max-w-2xl mx-auto">
        <p className="text-[10px] font-mono uppercase tracking-widest text-foreground/85">
          The Math
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-foreground tracking-tight">
          An SDR costs <span className="text-foreground/70">$72,000/yr</span>.
          <br />
          AutoPitch costs <span className="bg-gradient-to-r from-primary via-[hsl(var(--primary-glow))] to-[#22D3EE] bg-clip-text text-transparent drop-shadow-[0_0_24px_hsl(var(--primary)/0.5)]">$49/mo, only when it works</span>.
        </h2>
        <p className="text-sm md:text-base text-foreground/75 leading-relaxed">
          Outcome-based pricing. Your first qualified meeting is on us.
        </p>
      </Reveal>

      <Reveal stagger={70} className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
        {[
          {
            label: "Human SDR",
            value: "$60K–$120K",
            sub: "/year, fully loaded",
            tone: "muted",
          },
          {
            label: "Traditional outbound stack",
            value: "$500–$2,000+",
            sub: "/month per seat",
            tone: "muted",
          },
          {
            label: "AutoPitch",
            value: "$49",
            sub: "/month · first meeting free",
            tone: "primary",
          },
        ].map((tile) => (
          <div
            key={tile.label}
            className="rounded-2xl border p-6 space-y-2 backdrop-blur-sm"
            style={
              tile.tone === "primary"
                ? {
                    borderColor: "hsl(var(--success) / 0.4)",
                    background:
                      "linear-gradient(135deg, hsl(var(--success) / 0.10), hsl(var(--primary) / 0.06))",
                    boxShadow: "0 0 32px -12px hsl(var(--success) / 0.45)",
                  }
                : undefined
            }
          >
            <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">
              {tile.label}
            </p>
            {tile.tone === "primary" ? (
              <p
                className="text-3xl font-bold tracking-tight bg-clip-text text-transparent"
                style={{
                  backgroundImage:
                    "linear-gradient(90deg, hsl(var(--primary)), hsl(var(--primary-glow)), hsl(var(--success)))",
                }}
              >
                {tile.value}
              </p>
            ) : (
              <p className="text-3xl font-bold tracking-tight text-foreground">
                {tile.value}
              </p>
            )}
            <p className="text-xs text-muted-foreground">{tile.sub}</p>
          </div>
        ))}
      </Reveal>

      <Reveal delay={200} className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link to="/ai-sdr-roi-calculator">
          <Button variant="outline" size="lg" className="gap-2">
            Run the ROI calculator <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
        <p className="text-[11px] text-muted-foreground">
          No credit card. No contracts. Pay only when it works.
        </p>
      </Reveal>
    </div>
  );
}
